import { FC } from 'react';
import { injectIntl, IntlShape } from 'react-intl';
import { get } from 'lodash';
import { Typography, Grid } from '@material-ui/core';
import { translate } from 'containers/services/translate';
import { renderStatusTitle } from 'containers/TransactionManagerTimeLine/utils';
import messages from 'containers/TransactionManagerTimeLine/VictimInfo/messages';
import { STATUS_REJECTED } from 'containers/LawyerFeeNote/constants';

export interface DecisionRecapProps {
  intl: IntlShape;
  decision: any;
}

const DecisionRecap: FC<DecisionRecapProps> = props => {
  return (
    <Grid container direction="row">
      <Grid item xs={4}>
        <Typography style={{ fontSize: '15px', color: '#666' }}>
          {translate(messages.statusTitle, props)}
        </Typography>
        <Typography>
          {translate(renderStatusTitle(get(props.decision, 'status')), props)}
        </Typography>
      </Grid>
      <Grid item xs={4}>
        <Typography style={{ fontSize: '15px', color: '#666' }}>
          {translate(messages.decidedByTitle, props)}
        </Typography>

        <Typography>{get(props.decision, 'decidedBy')}</Typography>
      </Grid>

      {get(props.decision, 'status') === STATUS_REJECTED && (
        <Grid item xs={4}>
          <Typography style={{ fontSize: '15px', color: '#666' }}>
            {translate(messages.reasonTitle, props)}
          </Typography>
          <Typography>{get(props.decision, 'comment')}</Typography>
        </Grid>
      )}
    </Grid>
  );
};

export default injectIntl(DecisionRecap);
